var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from '@emotion/styled';
import { LocaleConsumer } from '../../providers/LocaleProvider';
import ControlButton from './ControlButton';
import ControlContainer from './ControlContainer';
import ArrowIcon from './ArrowIcon';
import { getControlsPositionX, getControlsMarginBottom } from './utils';
var PrevControlContainer = styled(ControlContainer)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
PrevControlContainer.defaultProps = __assign(__assign({}, ControlContainer.defaultProps), { left: '0' });
var PrevControlButton = styled(ControlButton)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), function (_a) {
    var shiftY = _a.shiftY;
    return shiftY && 'transform: translateY(-50%);';
}, function (_a) {
    var withOpacity = _a.withOpacity;
    return withOpacity && 'opacity: 0.45;';
});
export var PrevControl = function (_a) {
    var previousSlide = _a.previousSlide, currentSlide = _a.currentSlide, slideCount = _a.slideCount, slidesToShow = _a.slidesToShow, wrapAround = _a.wrapAround, isVisualNavigation = _a.isVisualNavigation, buttonSize = _a.size, arrowSize = _a.arrowSize, withOpacity = _a.withOpacity, shiftY = _a.shiftY, mb = _a.mb, leftProp = _a.left, displayProp = _a.display, positionTop = _a.positionTop, props = __rest(_a, ["previousSlide", "currentSlide", "slideCount", "slidesToShow", "wrapAround", "isVisualNavigation", "size", "arrowSize", "withOpacity", "shiftY", "mb", "left", "display", "positionTop"]);
    var disabled = slideCount === 1 ||
        (isVisualNavigation && currentSlide === 0) ||
        (!wrapAround && currentSlide === 0) ||
        slideCount <= slidesToShow;
    return (React.createElement(PrevControlContainer, { left: getControlsPositionX(isVisualNavigation, leftProp), "data-testid": "carousel-control-previous", top: positionTop },
        React.createElement(PrevControlButton, __assign({ themeHeight: buttonSize, themeWidth: buttonSize, withOpacity: withOpacity || !isVisualNavigation, shiftY: shiftY && isVisualNavigation, mb: getControlsMarginBottom(isVisualNavigation, mb), disabled: disabled, display: displayProp, onClick: previousSlide }, props),
            React.createElement(LocaleConsumer, null, function (l10n) { return (React.createElement(ArrowIcon, { arrowSize: arrowSize, alt: l10n.t('h24_carousel_prev_item') })); }))));
};
PrevControl.defaultProps = {
    isVisualNavigation: false,
    slidesToShow: 1,
    shiftY: true,
};
export default PrevControl;
var templateObject_1, templateObject_2;
